import { TicketApiResponseType } from "apps/registration/types/regFormApiResponse";
import { RegistrationRoute } from "apps/registration/routes/route";
import React from "react";
import groupBy from "lodash/groupBy";
import { useSearchParams } from "react-router-dom";
import { useRegDetail } from "shared/context/regDetail";
import { Base64Util } from "shared/utils/base64";
import { getAllUtmSearchParams, convertObjectToQueryString } from "apps/registration/utils";
import QueryParamKey from "../../../../shared/enums/QueryParamKey";

export default function useTicketPageService(ticketList: TicketApiResponseType[]) {
  const { registrationUrl } = useRegDetail();
  const [searchParams] = useSearchParams();

  const ticketListGroupedBySections = React.useMemo(
    () => groupBy(ticketList, "ticketPageSectionOrder") ?? [],
    [ticketList]
  );

  const getTicketUrl = React.useCallback(
    ticket => {
      const encodedTicketId = Base64Util.encode(ticket.id);
      let baseTicketUrl = `${registrationUrl}${RegistrationRoute.InitiateReg}?${QueryParamKey.FORM_ID}=${encodedTicketId}`;

      const couponCode = searchParams.get(QueryParamKey.COUPON_CODE);
      const sponsorOrgId = searchParams.get(QueryParamKey.SPONSOR_ORG_ID);
      const utmSearchParams = getAllUtmSearchParams(searchParams);

      if (Object.keys(utmSearchParams).length) {
        baseTicketUrl = baseTicketUrl.concat("&", convertObjectToQueryString(utmSearchParams));
      }
      if (couponCode) {
        return `${baseTicketUrl}&${QueryParamKey.COUPON_CODE}=${couponCode}`;
      }
      if (sponsorOrgId) {
        return `${baseTicketUrl}&${QueryParamKey.SPONSOR_ORG_ID}=${sponsorOrgId}`;
      }
      return baseTicketUrl;
    },
    [registrationUrl, searchParams]
  );

  return { ticketListGroupedBySections, getTicketUrl };
}
